import { render } from "./AccountPlatformHub.vue?vue&type=template&id=8fb2ad4e&scoped=true"
import script from "./AccountPlatformHub.vue?vue&type=script&lang=js"
export * from "./AccountPlatformHub.vue?vue&type=script&lang=js"

import "./AccountPlatformHub.vue?vue&type=style&index=0&id=8fb2ad4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fb2ad4e"]])

export default __exports__